import React, { useState } from 'react'
import { Box, Text } from 'rebass/styled-components'
import { send } from 'emailjs-com'
import AnimationWrapper from '../helpers/Animations'
import axios from 'axios-jsonp-pro'
import ConsignmentForm from '../components/forms/ConsignmentForm'
import RestorationForm from '../components/forms/RestorationForm'
import SalesForm from '../components/forms/SalesForm'
import CarForm from '../components/forms/CarForm'
import GenericForm from '../components/forms/GenericForm'

const Form = ({ options }) => {
    const [response, setResponse] = useState(null)

    const sendMail = async (data, template) => {
        const res = window?.verifyRecaptcha // Verification code in wrap-with-provider.js
        if (res.data && res.data.success && res.data.score >= 0.5) {
            send('service_piooj9s', template, data, process.env.GATSBY_EMAILJS_USER_ID)
                .then((result) => {
                    if (data.newsletter_consent) {
                        axios.jsonp('https://kidston.createsend.com/t/d/s/ahujij', {
                            params: {
                                'cm-name': data.from_name,
                                'cm-ahujij-ahujij': data.reply_to,
                            },
                        })
                    }
                    setResponse('Thank you! We will get in touch as soon as possible.')
                }, (error) => {
                    setResponse('Sorry. Something went wrong. Please try again later.')
                })
        } else {
            setResponse('Sorry. Something went wrong. Please try again later.')
        }
    }

    let output = null
    switch (options.type) {
    case 'consignment':
        output = <ConsignmentForm sendMail={sendMail} />
        break
    case 'restoration':
        output = <RestorationForm sendMail={sendMail} />
        break
    case 'sales':
        output = <SalesForm sendMail={sendMail} />
        break
    case 'enquiry':
        output = <CarForm sendMail={sendMail} />
        break
    default:
        output = <GenericForm sendMail={sendMail} />
    }

    return (
        <>
            {response ?
                <Box pt="sm">
                    <AnimationWrapper type='fade-up'>
                        <Box
                            my="md"
                            mx="auto"
                            py="sm"
                            px="md"
                            variant="container"
                            sx={{
                                borderColor: 'aquaDark',
                                borderStyle: 'solid',
                                borderWidth: '2px',
                                maxWidth: '320px',
                                textAlign: 'center',
                            }}
                        >
                            <Text as="p" color="aquaDark">
                                {response}
                            </Text>
                        </Box>
                    </AnimationWrapper>
                </Box> : output}
        </>
    )
}

export default Form
